var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245",
    transform: "translate(-377 -491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    transform: "translate(377 491)",
    fill: "#fff",
    stroke: "#51a800",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10,
    rx: 10.5,
    ry: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 10,
    rx: 9.5,
    ry: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M6317.244,747.5h-7.621",
    transform: "translate(-5925.673 -246.734)",
    fill: "none",
    stroke: "#51a800",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M7.621,0H0",
    transform: "translate(387.76 496.956) rotate(90)",
    fill: "none",
    stroke: "#51a800",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.2bcb0311124303220c3b6cbff0fa5f2e.svg";
export { ForwardRef as ReactComponent };